import { combineReducers } from 'redux';
import { user } from './user.js';
import { auth } from './auth.js';
import { permission } from './permission.js';
import { role } from './role.js';
import { modal } from './modal.js';
import { errors } from "./errors.js";
import { project } from './project.js';
import { attachment } from "./attachment.js";
import { donor } from "./donor.js";
import { asset } from "./asset.js";
import { timesheet } from "./timesheet.js";
import { leave } from "./leave.js";
import { gfaDocument } from "./gfa-document.js";
import { letter } from "./letter.js";
import { letterTemplate } from "./letter-template.js";
import { attachmentReducer } from "./chat/attachmentReducer.js";
import { contactReducer } from "./chat/contactReducer.js";
import { messageReducer } from "./chat/messageReducer.js";
import { calendarEntry } from "./calendar-entry.js";
import { folder } from "./folder.js";

export default combineReducers({
  attachmentReducer,
  contactReducer,
  messageReducer,

  user,
  auth,
  permission,
  role,
  modal,
  errors,
  project,
  attachment,
  donor,
  asset,
  timesheet,
  leave,
  gfaDocument,
  letter,
  letterTemplate,
  calendarEntry,
  folder
});


// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js